import { useTranslation } from "react-i18next";

import { cx, styled } from "simplydo/react/styled";
import { useTheme } from "simplydo/react/theme";
import { Dropdown } from "simplydo/react/ui/dropdown";
import { Pagination as UiPagination } from "simplydo/react/ui/pagination";

const PaginationContainer = styled.div`
  padding: 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;

  &.is-shadowed {
    background-color: #fff;
    box-shadow: 0 5px 10px rgb(0, 0, 0, 0.2);
  }
`;

const LimitContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
  .ui.selection.dropdown {
    min-width: 70px !important;
    width: 70px;
  }
  > span {
    display: block;
    margin: 0 10px;
    height: 20px;
  }
`;

type PaginationProps = {
  limit: number;
  page: number;
  total: number;
  limitValues?: number[];
  updateLimit?: (limit: number) => void;
  updatePage: (page: number) => void;
  shadowed?: boolean;
  text?: string;
  showLimiter?: boolean;
};

const Pagination = ({
  limit,
  page,
  total,
  limitValues = [15, 30, 50, 100],
  updateLimit,
  updatePage,
  shadowed,
  text,
  showLimiter = true,
}: PaginationProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <PaginationContainer className={cx(shadowed && "is-shadowed")}>
      {showLimiter && !theme.sizes.isMobile && (
        <LimitContainer>
          <span>Showing</span>
          <Dropdown
            variant="outline"
            options={limitValues.map((v) => ({
              key: v.toString(),
              text: v,
              value: v.toString(),
            }))}
            value={limit.toString()}
            onChange={(_e, { value }) =>
              updateLimit?.(parseInt(value as string, 10))
            }
          />
          <span>{`of ${total} total ${text ?? t("generic.ideas")}`}</span>
        </LimitContainer>
      )}
      <UiPagination
        onPageChange={(_e, { activePage }) => updatePage(activePage as number)}
        activePage={page || 1}
        totalPages={Math.floor(total / limit) + 1}
        boundaryRange={1}
        siblingRange={1}
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
      />
    </PaginationContainer>
  );
};

export default Pagination;
